import { chicagoHistoryPoints } from "@/lib/proposalData";
import { useDeployment } from "@/lib/DeploymentContext";

export default function ChicagoHistory() {
  const d = useDeployment();
  return (
    <section
      id="chicago"
      data-testid="section-chicago-history"
      className="bg-[#0A192F] text-[#F9F7F1] py-24 lg:py-32 relative overflow-hidden"
    >
      <div className="absolute inset-0 grain-overlay opacity-30" aria-hidden />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-3">
              <span className="h-px w-8 bg-[#D4AF37]" />
              <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#D4AF37]">
                The Service Connector Origin
              </span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-tight">
              Chicago. Six years.<br />
              <em className="italic text-[#D4AF37]">One hundred and five families.</em>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:pt-2 text-[#CBD5E1] leading-relaxed">
            <p>
              The Service Connector model was built in Chicago in the late 1990s
              and early 2000s as a deliberate response to {d.chicagoTransitionLine}
              faces today: dozens of well-funded individual programs that no one
              household could navigate alone. The Woodlawn Organization / WCDC
              formalized a single-relationship caseworker model — one human,
              multi-year horizon, every service line — that became a federally
              recognized blueprint for replication. George Broughton was inside
              that program for six years.
            </p>
          </div>
        </div>

        {/* Timeline */}
        <ol className="relative border-l border-[#F9F7F1]/20 pl-8 space-y-12">
          {chicagoHistoryPoints.map((p, i) => (
            <li key={i} data-testid={`chicago-timeline-${i}`} className="relative">
              <span className="absolute -left-[37px] top-1.5 w-3 h-3 bg-[#D4AF37] border-2 border-[#0A192F]" />
              <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#D4AF37] mb-2">
                {p.period}
              </div>
              <h3 className="font-display text-2xl mb-3">{p.title}</h3>
              <p className="text-[#CBD5E1] leading-relaxed max-w-3xl">{p.body}</p>
            </li>
          ))}
        </ol>

        <div className="mt-16 grid sm:grid-cols-3 gap-px bg-[#F9F7F1]/15 border border-[#F9F7F1]/15">
          {[
            { k: "105", v: "Families on George's continuous Chicago caseload" },
            { k: "6 years", v: "Tenure at The Woodlawn Organization / WCDC" },
            { k: "Federally recognized", v: "Blueprint for high-touch case management" },
          ].map((s, i) => (
            <div key={i} className="bg-[#0A192F] p-6 lg:p-8">
              <div className="font-display text-2xl lg:text-3xl text-[#D4AF37] leading-tight">{s.k}</div>
              <div className="font-mono text-[10px] uppercase tracking-widest text-[#CBD5E1] mt-2">
                {s.v}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
